export default __webpack_public_path__ + "static/media/img-0213-mexico-full-face.bb4aa467.png";